<template>
  <AuthCard logo-disabled class="auth-card--forgot-password">
    <Form action="/password_reminder" @success="onSuccess">
      <div class="container px-0">
        <div v-if="message" class="row">
          <div class="col">
            <div class="alert alert-info">
              {{ message }}
            </div>
          </div>
        </div>

        <template v-else>
          <div class="row">
            <div class="col">
              <h2>{{ $t('front.cant_sign_in') }}</h2>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              {{ $t('front.password_reminder_message') }}
            </div>
          </div>

          <div class="row">
            <div class="col">
              <FormControl
                  ref="emailInputRef"
                  v-model="email"
                  name="email"
                  label-disabled
                  input-group-class="input-group-lg"
              />
            </div>
          </div>
        </template>

        <div class="row mt-5">
          <div class="col">
            <Button v-if="!message" :disabled="!email" type="submit" class="btn-primary btn-lg btn-rounded w-100">
              {{ $t('front.remind_me') }}
            </Button>

            <a :href="makeLink('/auth/login')" @click.prevent="router.push({ name: 'auth.login'})" class="btn btn-lg btn-rounded w-100 borderless mt-2 text-primary">
              {{ $t('global.back') }}
            </a>
          </div>
        </div>
      </div>
    </Form>
  </AuthCard>
</template>
<script setup>
import Form from "@/js/Elements/Form/Form.vue";
import FormControl from "@/js/Elements/Form/FormControl.vue";
import Button from "@/js/Elements/Button.vue";
import {useRouter} from "vue-router";
import {onMounted, ref} from "vue";
import AuthCard from "@/js/Views/Auth/AuthCard.vue";
import {makeLink} from "@/js/Plugins/Http.js";

const router = useRouter();
const message = ref(null);
const emailInputRef = ref();
const email = ref();

onMounted(() => {
  emailInputRef.value.focus();
});
function onSuccess(response) {
  message.value = response?.message;
}
</script>